import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Camera } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

const BASE = process.env.REACT_APP_BACKEND_URL;
const CONFERENCE_END = new Date('2026-11-01T12:00:00-05:00').getTime();

export const ConferencePhotos = () => {
  const [photos, setPhotos] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    axios.get(`${BASE}/api/chapter-photos/conference-2026`).then((r) => setPhotos(r.data.items || [])).catch(() => setPhotos([]));
  }, []);
  if (!photos.length && Date.now() < CONFERENCE_END) return null;

  return (
    <section id="photos" className="max-w-7xl mx-auto px-4 pt-14 scroll-mt-28" data-testid="conference-photos">
      <h2 className="font-display text-3xl md:text-4xl text-cbtu-cream mb-2 flex items-center gap-3"><Camera className="text-gold" size={26} /> CONFERENCE <span className="gold-text-fill">PHOTOS</span></h2>
      {photos.length === 0 ? (
        <div className="card-dark rounded-md p-8 text-cbtu-text/90" data-testid="conference-photos-coming-soon">Photos from the 2026 Regional Conference will be available and posted here soon. Check back!</div>
      ) : (
        <>
          <p className="text-cbtu-muted text-sm mb-6">Moments from the 2026 Regional Conference in Jacksonville. Tap a photo to enlarge.</p>
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [&>*]:mb-4">
            {photos.map((p) => (
              <button key={p.id} type="button" onClick={() => setOpen(p)} className="block w-full break-inside-avoid rounded-md overflow-hidden gold-border group" data-testid={`conference-photo-${p.id}`}>
                <img src={`${BASE}${p.src}`} alt={p.caption || 'CBTU Region III 2026 conference photo'} loading="lazy" className="w-full h-auto block transition-transform duration-500 group-hover:scale-[1.02]" />
                {p.caption && <div className="bg-cbtu-black/80 px-3 py-2 text-left text-sm text-cbtu-cream">{p.caption}</div>}
              </button>
            ))}
          </div>
        </>
      )}
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-5xl bg-cbtu-black border-gold/40 p-3" data-testid="conference-photo-lightbox">
          <DialogTitle className="text-cbtu-cream text-sm px-1">{open?.caption || 'Conference photo'}</DialogTitle>
          {open && <img src={`${BASE}${open.src}`} alt={open.caption || 'Conference photo'} className="w-full max-h-[80vh] object-contain" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};
